<template>
  <menu-trigger icon="more_horiz" class="rounded-full hover:bg-primary-light">
    <menu-item v-for="item in items"
               v-show="item.itemExists"
               :label="item.label"
               :key="item.label"
               :label-classes="item.classes"
               @click.native="$emit(item.emit)"
    >
      <template #icon="{ isHover }">
        <component :is="item.component"
                   :icon="item.icon"
                   :size="item.size"
                   class="h-5 w-5"
                   :class="isHover ? `${item.classes} text-primary-focus` : item.classes"
        />
      </template>
    </menu-item>
  </menu-trigger>
</template>

<script>
import MenuTrigger from './MenuTrigger.vue'
import MenuItem from './MenuItem.vue'
import EditIcon from '@/assets/images/icons/EditIcon'
import HideIcon from '@/assets/images/icons/HideIcon'
import DeleteIcon from '@/assets/images/icons/DeleteIcon'
import EyeIcon from '@/assets/images/icons/EyeIcon.vue'
import ReindexIcon from '@/assets/images/icons/ReindexIcon.vue'

export default {
  name: 'SideListMenu',

  components: {
    MenuTrigger,
    MenuItem,
    EditIcon,
    HideIcon,
    DeleteIcon,
    EyeIcon,
    ReindexIcon
  },

  props: {
    items: {
      type: Array,
      required: true
    }
  }
}
</script>
